<template>
	<div class="diag-table">
		<table>
			<thead>
				<tr class="level-header">
					<th></th>
					<template v-for="(item, index) in diagnosisData">
						<th :key="`header-${index}`" :colspan="3" class="qualification-header">{{ item.ZZMC }}</th>
					</template>
				</tr>
				<tr class="type-header">
					<th class="item-name" rowspan="2">类型</th>
					<template v-for="(item, index) in diagnosisData">
						<th :key="`subheader1-${index}`" class="existing-header">现有</th>
						<th :key="`subheader2-${index}`" class="standard-header">标准要求</th>
						<th :key="`subheader3-${index}`" class="result-header">结果</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<!-- 动态生成行 -->
				<template v-for="(rowType, rowIndex) in getUniqueTypes()">
					<tr :key="`row-${rowIndex}`">
						<!-- 不需要合并单元格 -->
						<td class="item-type br">{{ rowType.TYPE }}</td>

						<template v-for="(item, colIndex) in diagnosisData">
							<template v-if="getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC)">
								<td :key="`cell-existing-${rowIndex}-${colIndex}`" class="existing-value">
									{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).EXISTING }}
								</td>
								<td :key="`cell-standard-${rowIndex}-${colIndex}`" class="standard-value">
									{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).STANDARD_REQUIREMENTS }}
								</td>
								<td
									:key="`cell-result-${rowIndex}-${colIndex}`"
									:class="[
										'result-value',
										getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).WHETHER ? 'success' : 'error'
									]"
								>
									{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).RESULTS }}
								</td>
							</template>
							<template v-else>
								<td :key="`cell-empty1-${rowIndex}-${colIndex}`">-</td>
								<td :key="`cell-empty2-${rowIndex}-${colIndex}`">-</td>
								<td :key="`cell-empty3-${rowIndex}-${colIndex}`">-</td>
							</template>
						</template>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { getDiagnosisRecordDetail } from '@/api/certTreasure/diagnosis'
	import { ENUM_DIAGNOSIS_TYPE } from '@/enum'

	// 房地产开发诊断结果比对
	export default {
		name: 'RealEstateDevelopmentDiagnosisResult',
		components: {},
		props: {
			// 诊断记录id
			recordId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 诊断结果数据
				diagnosisData: []
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryRecordDetail()
		},
		methods: {
			// 查询诊断结果对比json
			handleQueryRecordDetail() {
				const params = {
					recordId: this.recordId
				}

				getDiagnosisRecordDetail(params).then(response => {
					const { data } = response

					if (data && data.diagnosisInfo) {
						// 诊断类型
						const diagnosisType = data.diagnosisType
						// 诊断类型对应的名称
						let diagnosisTypeName = ''
						// 遍历诊断类型枚举，查找匹配的类型名称
						Object.keys(ENUM_DIAGNOSIS_TYPE).forEach(key => {
							if (diagnosisType.includes(key)) {
								diagnosisTypeName = ENUM_DIAGNOSIS_TYPE[key]
							}
						})
						// 存储报告生成状态
						this.generateState = data.generateState
						const diagnosisResultData = JSON.parse(data.diagnosisInfo)
						diagnosisResultData[0].ZZMC = '房地产开发企业资质' + '-' + diagnosisTypeName
						diagnosisResultData[0].ZZCODE = '111'
						console.log('diagnosisResultData:', diagnosisResultData)

						this.diagnosisData = diagnosisResultData
					}
				})
			},

			// 获取所有唯一的类型，用于生成表格行
			getUniqueTypes() {
				const types = []
				this.diagnosisData.forEach(item => {
					item.RESULT.forEach(option => {
						// types.add(option.TYPE)
						types.push({
							TYPE: option.TYPE
							// 如果需要合并单元格就打开
							// ZZMC: option.ZZMC
						})
					})
				})
				return types
			},

			// 根据类型获取对应的选项
			getOptionByType(options, type, zzmc) {
				return options.find(option => option.TYPE === type && option.ZZMC === zzmc)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../styles/diagnosisTable.scss';
</style>
